import { Link } from 'react-router-dom'
import { Sparkles } from 'lucide-react'
import { useChangelog } from '@/hooks/use-changelog'
import { openCookiePreferences } from '@/lib/cookie-consent'

export function Footer() {
  const { hasUnseen } = useChangelog()
  const year = new Date().getFullYear()

  return (
    <footer className="mt-12 border-t pt-6 pb-2">
      <div className="flex flex-col items-center justify-between gap-3 text-xs text-muted-foreground sm:flex-row">
        <div className="flex items-center gap-3">
          <span>© {year} Rundown</span>
          <button
            type="button"
            onClick={openCookiePreferences}
            className="transition-colors hover:text-foreground"
          >
            Cookie preferences
          </button>
        </div>
        <Link
          to="/changelog"
          className="group relative inline-flex items-center gap-1.5 transition-colors hover:text-foreground"
        >
          <Sparkles className="h-3.5 w-3.5" />
          What’s new
          {hasUnseen && (
            <span className="relative ml-0.5 flex h-2 w-2" aria-label="New updates available">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-primary opacity-75" />
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary" />
            </span>
          )}
        </Link>
      </div>
    </footer>
  )
}
